import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

//COMPONENTS
import * as CurrencyMethods from "../../../../../admin/files/currencyMethods";

//ACTIONS
import * as PrintingShopActions from "../../../../../../../envStore/actions/3dPrintingShop";

//STYLES
import * as CheckoutStyles from "../../styles/basket/checkout";

function BasketSideBar() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const printingShop = useSelector((state) => state.printingShop);

    function handleUpdatBasket() {
        dispatch(PrintingShopActions.UpdateBasketOnServer());
    }

    function handleGoToCheckout() {
        navigate("../checkout");
    }

    return (
        <div style={CheckoutStyles.body}>
            {printingShop.items.length > 0 && (
                <div>
                    {printingShop.partlyPaidItems ? (
                        <div>
                            <div style={CheckoutStyles.redText}>
                                This basket contain items which you are paying deposits for. The remianing ammount will be due when half the the model
                                is built
                            </div>
                            <br />
                            Basket Full Total: £{CurrencyMethods.FormatCurrency(printingShop.basketTotalWithoutDisounts)} <br />
                            <strong>To Pay Today: £{CurrencyMethods.FormatCurrency(printingShop.basketTotal)} </strong> <br />
                            <div style={CheckoutStyles.redText}>
                                To Pay Later: £
                                {CurrencyMethods.FormatCurrency(
                                    CurrencyMethods.WorkOutRemainingPayment(printingShop.basketTotalWithoutDisounts, printingShop.basketTotal)
                                )}
                            </div>
                            <br />
                            <strong>Sub Total: £{CurrencyMethods.FormatCurrency(printingShop.basketTotal)}</strong> <br /> <br />
                        </div>
                    ) : (
                        <div>
                            {printingShop.deals.length > 0 && (
                                <div style={CheckoutStyles.redText}>
                                    <strong>Included Deals</strong>
                                    {printingShop.deals.map((deal, index) => {
                                        return (
                                            <p key={index}>
                                                {deal.id}. {deal.title}
                                            </p>
                                        );
                                    })}
                                    <br />
                                    <br />
                                </div>
                            )}
                            <strong>Sub Total: £{CurrencyMethods.FormatCurrency(printingShop.basketTotal)}</strong> <br /> <br />
                        </div>
                    )}
                    <div style={CheckoutStyles.checkoutBtn}>
                        <div>
                            {printingShop.updateBtn ? (
                                <Button variant="success" style={CheckoutStyles.checkoutButton} onClick={handleUpdatBasket}>
                                    Update
                                </Button>
                            ) : (
                                <Button variant="success" style={CheckoutStyles.checkoutButton} onClick={handleGoToCheckout}>
                                    Go To Checkout
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default BasketSideBar;
